var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigationClock = function SvgNavigationClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m612.924 769.076 60.152-60.152-149.077-151.087V372h-85.998v222.154zM480.067 987.999q-85.476 0-160.684-32.44-75.209-32.44-130.842-88.05T100.454 736.72q-32.453-75.177-32.453-160.653 0-85.732 32.499-161.166t88.21-131.234 130.788-87.733q75.075-31.933 160.435-31.933 85.722 0 161.148 31.92 75.425 31.92 131.238 87.71 55.814 55.791 87.747 131.212t31.933 161.173-31.92 160.621-87.697 130.603-131.18 88.247-161.135 32.512M480 902q136 0 231-95t95-231-95-231-231-95-231 95-95 231 95 231 231 95"
  })));
};
export default SvgNavigationClock;